import { Stack } from '@mui/material';

import { isDefined } from 'common';

import { AgenticChatContent } from './Content';
import { AgenticChatNewSession } from './NewSession';
import { AgenticChatToolbar } from './Toolbar';
import { useAgenticChatContext } from '../../components/AgenticChat/context';

export function AgenticChatPage() {
  const { sessionId, overlayDismissalCount } = useAgenticChatContext();

  return (
    <Stack height="100%" overflow="hidden">
      <AgenticChatToolbar key={overlayDismissalCount} />
      <Stack direction="row" sx={{ padding: 0, overflowY: 'auto', flex: 1, minHeight: 0 }}>
        {!isDefined(sessionId) ? (
          <AgenticChatNewSession />
        ) : (
          <AgenticChatContent key={sessionId} sessionId={sessionId} />
        )}
      </Stack>
    </Stack>
  );
}
